(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');
    module.factory('DayschemeService', ['$http', 'HelperService', 'SharedAgendaService', DayschemeServiceFn]);

    /* service for requesting dayschemes */
    function DayschemeServiceFn($http, HelperService, SharedAgendaService) {
        var baseUrl = '/api/dayschemes/';

        var service = {
            dayschemesOfWeekscheme: dayschemesOfWeekscheme,
            dayschemesOfWeekschemeByWeekday: dayschemesOfWeekschemeByWeekday,
            dayschemesOfUser: dayschemesOfUser,
            save: save,
            update: update,
            saveWeek: saveWeek,
            get: get,
            deactivate: deactivate,
            importHolidays: importHolidays,
            globalHolidays: globalHolidays,
            holiday: holiday,
            getByDate: getByDate,
            special: special
        };

        return service;

        /* special -> users dayschemes and global holidays */
        function special(id) {
            return $http.get(baseUrl + 'users/' + id + '/agendas/' + SharedAgendaService.data.currentAgenda.id + '/special').then(function (response) {
                return response.data;
            });
        }

        /* query all dayschemes weekscheme */
        function dayschemesOfWeekscheme(weekschemeId) {
            return $http.get(baseUrl + 'weekschemes/' + weekschemeId + '/agendas/' + SharedAgendaService.data.currentAgenda.id).then(function (response) {
                return response.data;
            });
        }

        /* query all dayschemes weekscheme */
        function dayschemesOfWeekschemeByWeekday(userId, date) {
            return $http.get(baseUrl + 'weekschemes/' + userId + '/agendas/' + SharedAgendaService.data.currentAgenda.id + '/' + HelperService.backendDate(date)).then(function (response) {
                return response.data;
            });
        }

        /* query all dayschemes of user */
        function dayschemesOfUser(userId, all, isReadonly, date) {
            return $http({
                method: 'GET',
                url: baseUrl + 'users/' + userId + '/agendas/' + SharedAgendaService.data.currentAgenda.id,
                params: {
                    all: all,
                    isReadonly: isReadonly,
                    date: HelperService.backendDate(date)
                }
            }).then(function (response) {
                return response.data;
            });
        }

        /* get day */
        function get(id) {
            return $http.get(baseUrl + id + '/agendas/' + SharedAgendaService.data.currentAgenda.id).then(function (response) {
                return response.data;
            });
        }


        /* save whole week */
        function saveWeek(dayschemes, agendaId) {
            return $http.post(baseUrl + "weekschemes/agendas/" + agendaId, dayschemes).then(function (response) {
                return response.data;
            });
        }

        /* save day */
        function save(day) {
            return $http.post(baseUrl + 'agendas/' + SharedAgendaService.data.currentAgenda.id, day).then(function (response) {
                return response.data;
            });
        }

        /* update day */
        function update(id, day) {
            return $http.put(baseUrl + id + '/agendas/' + SharedAgendaService.data.currentAgenda.id, day).then(function (response) {
                return response.data;
            });
        }

        /* deactivate */
        function deactivate(id) {
            return $http.delete(baseUrl + id + '/agendas/' + SharedAgendaService.data.currentAgenda.id).then(function (response) {
                return response.data;
            });
        }

        /* import holidays by country */
        function importHolidays(countryId, from, to) {
            return $http.post(baseUrl + 'holidays/import/' + countryId + '/' + from + '/' + to).then(function (response) {
                return response.data;
            });
        }

        /* list all global holidays */
        function globalHolidays(userId, all, fromDate) {
            return $http.get(baseUrl + 'holidays/users/' + (userId ? userId + '/' : '') + 'agendas/' + SharedAgendaService.data.currentAgenda.id + '/' + HelperService.backendDate(fromDate) + '/' + (all ? all : false)).then(function (response) {
                return response.data;
            });
        }

        /* get holiday by date and user */
        function holiday(userId, date) {
            return $http.get(baseUrl + 'holidays/users/' + userId + '/agendas/' + SharedAgendaService.data.currentAgenda.id + '/' + HelperService.backendDate(date)).then(function (response) {
                return response.data;
            });
        }

        /* get dayscheme for date */
        function getByDate(userId, date) {
            return $http.get(baseUrl + 'date/' + HelperService.backendDate(date) + '/' + userId + '/agendas/' + SharedAgendaService.data.currentAgenda.id).then(function (response) {
                return response.data;
            });
        }
    }
})();